import * as Yup from 'yup';
import { SORTBY_OPTIONS, controllers } from '../../utils/constants';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createLocalizedOptions } from '../../pages/root/App';
import messages from '../ControllerExperience/messages';
import siteMessages from '../../pages/root/siteMessages';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const FpsControllerExperience = ({
  values,
  errors,
  setFieldValue,
  updateSchema
}: Props) => {
  const intl = useIntl();

  const controllersOptions = createLocalizedOptions(
    controllers,
    messages,
    SORTBY_OPTIONS.Name
  );

  useEffect(() => {
    const fpsControllerExperienceSchema = {
      fpsControllerIds: Yup.array(Yup.number()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(fpsControllerExperienceSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="fpsControllerIds"
      label={intl.formatMessage({ ...messages.fpsControllers })}
      isMulti={true}
      options={controllersOptions}
      value={values.fpsControllerIds}
      error={errors.fpsControllerIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default FpsControllerExperience;
